<div class="bg-white rounded shadow">
  <div class="profile-edit-box m-4">
    <!-- Hotkeys Info -->
    <div class="hotkeys-info mb-3 p-2 bg-light rounded" style="font-size: 0.85rem; color: #666">
      <strong>{{ 'hotkeys' | translate }}:</strong>
      <span class="ms-2">{{ getModifierKey() }}+N - {{ 'add_ttn' | translate }}</span>
      <span class="ms-2">•</span>
      <span class="ms-2">{{ getModifierKey() }}+F - {{ 'search' | translate }}</span>
      <span class="ms-2">•</span>
      <span class="ms-2">Esc - {{ 'clear_selection' | translate }}</span>
    </div>

    <div class="d-flex align-items-center pt-2">
      <app-search (onValueChange)="onSearchChange($event)"></app-search>
      @if (selectionTable.selected.length) {
        <div>
          <app-button #t="matMenuTrigger" [matMenuTriggerFor]="menu">
            <div class="d-flex flex-nowrap align-items-center">
              <span class="selected_dropdown">({{ selectionTable.selected.length }}) {{ 'selected' | translate }}</span>
              <app-icon class="align-middle selected_dropdown">{{
                t.menuOpen ? 'expand_less' : 'expand_more'
              }}</app-icon>
            </div>
          </app-button>
          <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="p-0">
            @for (item of bulkActionList; track item; let i = $index) {
              <button mat-menu-item (click)="bulkActionPopup(item)">
                {{ item.label | translate }}
              </button>
            }
          </mat-menu>
        </div>
      }
      <div class="flex-fill"></div>
      <app-button (onChangeClick)="onAdd()">{{ 'add_ttn' | translate }}</app-button>
    </div>
    @if (isLoader) {
      <div class="d-flex justify-content-center">
        <app-loader size="small"></app-loader>
      </div>
    } @else {
      @if (dataSource$ | async; as dataSource) {
        <app-table
          (menuSelected)="onActionChange($event)"
          (onPaginationChange)="onPaginationChange($event)"
          (onSortChange)="onSortChange($event)"
          [selection]="selectionTable"
          [dataSource]="dataSource"
          [visibleColumnKeys]="visibleColumns"
          class="w-100"
        ></app-table>
      }
    }
  </div>
</div>
